/**
 * Link-based partner program: persist ?ref= / utm_campaign in a cookie for OAuth and email signup.
 */
const COOKIE_NAME = "nrs_partner_ref";
const MAX_AGE_SEC = 90 * 24 * 60 * 60;

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}

/**
 * If the URL contains ref or utm_campaign (lowercase hex/alnum code), store for later signup/OAuth.
 */
export function capturePartnerCodeFromUrl() {
  if (typeof window === "undefined") return;
  const sp = new URLSearchParams(window.location.search);
  const ref = (sp.get("ref") || sp.get("utm_campaign") || "").trim().toLowerCase();
  if (!ref || ref.length < 8 || ref.length > 32) return;
  if (!/^[a-z0-9]+$/.test(ref)) return;
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(ref)}; Max-Age=${MAX_AGE_SEC}; Path=/; SameSite=Lax`;
}

export function getStoredPartnerCode() {
  const v = readCookie(COOKIE_NAME);
  return v && v.length >= 8 ? v : null;
}

/**
 * Query fragment for Composer OAuth initiation (merged into url_params cookie chain).
 */
export function partnerCodeQuerySuffix() {
  const r = getStoredPartnerCode();
  return r ? `ref=${encodeURIComponent(r)}` : "";
}
